import { TECH_PROJECT_NAME } from 'hooks/permission/constants';
import type { ProjectNames } from 'hooks/permission/types';

import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LinkIcon from '@mui/icons-material/Link';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';

import { ActiveAppLinks, BranchesList, LinksList } from 'constants/routerPath';

import type { MenuGroup } from './types';

const test: MenuGroup = {
    id: 'group-test',
    title: 'Tests',
    type: 'group',
    children: [
        {
            id: 'branches',
            title: 'Branches',
            type: 'item',
            url: BranchesList,
            icon: AccountTreeIcon,
            breadcrumbs: false,
            permission_name: 'branches',
        },
        {
            id: 'links',
            title: 'Links',
            type: 'item',
            url: LinksList,
            icon: LinkIcon,
            breadcrumbs: false,
            permission_name: 'links',
        },
        {
            id: 'active-app-links',
            title: 'Active app links',
            type: 'item',
            url: ActiveAppLinks,
            icon: PhonelinkSetupIcon,
            breadcrumbs: false,
            permission_name: 'links',
            requiredProject: TECH_PROJECT_NAME as ProjectNames,
        },
    ],
};

export default test;
